export default __webpack_public_path__ + "static/media/officeBuilding.7dcd8b66.svg";